import { createContext, useContext } from 'react';
import type { CredentialResponse } from '@react-oauth/google';

/**
 * The context object and its hook, split out of AuthContext.tsx.
 *
 * That file exported both a component (AuthProvider) and a hook (useAuth),
 * which breaks the fast-refresh boundary — react-refresh/only-export-components
 * flagged it. Mirrors application/web/asknim/src/auth/context.ts, which already splits
 * them this way.
 */

export interface AdminUser {
  email: string;
}

export interface AuthContextType {
  user: AdminUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  handleGoogleSuccess: (response: CredentialResponse) => void;
  handleGoogleError: () => void;
  logout: () => void;
  error: string | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
}
